<template>
    <v-app id="inspire" class="gb mobile">
        <div class="module-container">
            <div class="home">
                <div class="banner">
                    <img :src="require('@/assets/logo.svg')" alt/>
                    <p>
                        Disable Email Notifications
                        </p>
                </div>
            </div>
        </div>
    </v-app>
</template>
<script>
    export default {
        created() {
            this.$store.dispatch("Authenticate/disableEmailNotifications", this.$route.params.owner_id);
        },
    }
</script>

<style lang="scss">
    @import '@/assets/css/landing';
</style>
